/** Exception types */
export const DRIVING_EXPERIENCE = 'driving_experience';
export const EMPLOYMENT_MULTIDOC = 'employment_proof_multidoc';

/** Verification objects */
export const MATRIX_VERIFICATION = 'matrix_verification';
